module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/800f6f1573677d59954e8d3164602287.svg";